<template>
  <div class="student-detail">
    <el-table
    :data="tableData"
    style="width: 100%">
    <div slot="empty" class="no-data">
      <EmptyContent/>
    </div>
    <el-table-column label="当前打地基课程" align="center">
        <el-table-column
        prop="name"
        label="学生姓名"
        width="120"
        align="center"
        >
      </el-table-column>
        <el-table-column
          prop="nearLesson"
          label="最近打地基课程"
          width="350"
        >
        </el-table-column>
        <el-table-column
          prop="type"
          label="打地基类型"
          width="120"
          align="center"
          >
        </el-table-column>
    </el-table-column>
    <el-table-column label="学情" align="center">
      <el-table-column
        prop="prevRate"
        label="先测正答率"
        width="120"
        align="center"
        >
      </el-table-column>
       <el-table-column
        prop="nextRate"
        label="学后正答率"
        width="120"
        align="center"
        >
      </el-table-column>
       <el-table-column
        prop="averRate"
        label="平均知识点正答率" align="center"
        >
      </el-table-column>
    </el-table-column>
     <el-table-column label="未掌握知识点能力值对比" align="center">
      <el-table-column
        prop="prevNum"
        label="先测未掌握知识点数"
        align="center"
        >
      </el-table-column>
       <el-table-column
        prop="prevAver"
        label="学前平均能力值"
        width="80"
        align="center">
      </el-table-column>
       <el-table-column
        prop="nextAver"
        label="学后平均能力值"
        width="80"
        align="center"
        >
      </el-table-column>
    </el-table-column>
    </el-table>
  </div>
</template>

<script>
import EmptyContent from '@/views/pt/components/empty-content.vue';

export default {
  name: 'StudentDetail',
  components: {
    EmptyContent,
  },
  data() {
    return {
      tableData: [{
        nearLesson: '2019小学数学人教版三年级第一学期正式课',
        name: '王小虎',
        type: '巩固学一',
        prevRate: '89%',
        nextRate: '89%',
        averRate: '89%',
        prevNum: 1,
        prevAver: 0.33,
        nextAver: 0.93,
      },
      {
        nearLesson: '2019小学数学人教版三年级第一学期正式课',
        name: '王小虎',
        type: '巩固学一',
        prevRate: '89%',
        nextRate: '89%',
        averRate: '89%',
        prevNum: 1,
        prevAver: 0.33,
        nextAver: 0.93,
      }, {
        nearLesson: '2019小学数学人教版三年级第一学期正式课',
        name: '王小虎',
        type: '巩固学一',
        prevRate: '89%',
        nextRate: '89%',
        averRate: '89%',
        prevNum: 1,
        prevAver: 0.33,
        nextAver: 0.93,
      }, {
        nearLesson: '2019小学数学人教版三年级第一学期正式课',
        name: '王小虎',
        type: '巩固学一',
        prevRate: '89%',
        nextRate: '89%',
        averRate: '89%',
        prevNum: 1,
        prevAver: 0.33,
        nextAver: 0.93,
      }, {
        nearLesson: '2019小学数学人教版三年级第一学期正式课',
        name: '王小虎',
        type: '巩固学一',
        prevRate: '89%',
        nextRate: '89%',
        averRate: '89%',
        prevNum: 1,
        prevAver: 0.33,
        nextAver: 0.93,
      }, {
        nearLesson: '2019小学数学人教版三年级第一学期正式课',
        name: '王小虎',
        type: '巩固学一',
        prevRate: '89%',
        nextRate: '89%',
        averRate: '89%',
        prevNum: 1,
        prevAver: 0.33,
        nextAver: 0.93,
      },
      {
        nearLesson: '2019小学数学人教版三年级第一学期正式课',
        name: '王小虎',
        type: '巩固学一',
        prevRate: '89%',
        nextRate: '89%',
        averRate: '89%',
        prevNum: 1,
        prevAver: 0.33,
        nextAver: 0.93,
      },
      {
        nearLesson: '2019小学数学人教版三年级第一学期正式课',
        name: '王小虎',
        type: '巩固学一',
        prevRate: '89%',
        nextRate: '89%',
        averRate: '89%',
        prevNum: 1,
        prevAver: 0.33,
        nextAver: 0.93,
      },
      {
        nearLesson: '2019小学数学人教版三年级第一学期正式课',
        name: '王小虎',
        type: '巩固学一',
        prevRate: '89%',
        nextRate: '89%',
        averRate: '89%',
        prevNum: 1,
        prevAver: 0.33,
        nextAver: 0.93,
      },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.student-detail{
  margin-top: 25px;
}
::v-deep {
  thead{
    tr:first-child{
       th:nth-child(n-3){
       background-color: #E3F0FEFF !important;
        .cell{
        color: #909399;
      }
    }
  }
}
}
</style>
